const notice = {
    start_date: '',
    expire_date: '',
    title: '',
    level: 'info',
    text: '',
    sent_to_all: true,
};

export default notice
